// Copyright (c) 2025. All Rights Reserved.
// Proprietary software of OPX Technology
// author: ckhoo

function show_login_denied_message() {
    let loginElm = $("#page-login form.form-signin.form-login");
    if (loginElm.length === 0) {
        return
    }
    frappe.call({
        method: "oro247app.remote_api.system.is_denied_access",
        callback: function (r) {
            if (!r.exc) {
                if (r.message.message) {
                    loginElm.append(`
                    <div class="alert desk-alert blue" style="width: 100%; margin-top: 20px; animation-name: null; animation-duration: null;">
                        <div class="alert-message-container">
                            <div class="alert-title-container">
                                <div>
                                    <svg class="icon  icon-lg" style="" aria-hidden="true">
                                        <use class="" href="#icon-solid-info"></use>
                                    </svg>
                                </div>
                                <div class="alert-message">${r.message.message.title}</div>
                            </div>
                            <div class="alert-subtitle" style="margin-top: 10px">${r.message.message.body}</div>
                        </div>
                    </div>
                    `);
                }
            }
        },
    });
}

document.addEventListener("DOMContentLoaded", function() {
    show_login_denied_message();
});
